export default "__VITE_ASSET__eae6845f__"